import {Expressions} from '@packages/systems/wfdl';
import {ExpressionElement} from '@packages/systems/wfdl-ast';
import {weakMemo} from '@packages/utilities/memo';
import {getDynamoBindingPaths} from '@packages/systems/dynamo/wfdl';

type BindingPaths = ReadonlyArray<string[]>;

/**
 * Returns true if the two elements have different Dynamo bindings.
 */
export function haveDifferentUniversalBindings(
  elementA: ExpressionElement,
  elementB: ExpressionElement
): boolean {
  if (elementA === elementB) {
    return false;
  }

  const pathsA = getDynamoBindingPaths(Expressions.getElementData(elementA));
  const pathsB = getDynamoBindingPaths(Expressions.getElementData(elementB));

  if (pathsA.length === 0 && pathsB.length === 0) {
    return false;
  }

  return hashBindingPaths(pathsA) !== hashBindingPaths(pathsB);
}

const hashBindingPaths = weakMemo((bindingPaths: BindingPaths): string => {
  const pathHashes = bindingPaths.map((path) => path.join('.'));
  pathHashes.sort();

  let hash = '';
  let prevHash;

  for (let i = 0; i < pathHashes.length; i++) {
    if (pathHashes[i] === prevHash) {
      // remove duplicate binding paths from hash
      continue;
    }
    prevHash = pathHashes[i];
    hash += `>${prevHash}`;
  }

  return hash;
});
